export const EMAIL_PHONE_LABELS = {
  email: 'e-mail',
  phone: 'phone'
};

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX = /^(?=.{8,128}$)[\x20-\x7E]+$/;
export const ONLY_LATIN_REGEX = /^[A-Za-z]+$/;
export const CYRILLIC_LATIN_REGEX = /^[A-Za-zА-Яа-яЁё]+$/;
export const DOCUMENT_NUMBER_REGEX = /^[A-Z0-9]+$/;

export const OPERATORS = [
  {
    label: 'All answers',
    value: 'AND'
  },
  {
    label: 'At least one answer',
    value: 'OR'
  }
];
